import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiIconTooltipButtonComponent } from './fi-icon-tooltip-button.component';
import { MatIconModule } from '@angular/material/icon';
import { InfoIconModule } from '../info-icon/info-icon.module';

@NgModule({
    declarations: [FiIconTooltipButtonComponent],
    imports: [CommonModule, MatIconModule, InfoIconModule],
    exports: [FiIconTooltipButtonComponent],
})
export class FiIconTooltipButtonModule {}
